var React = require('react');

function IconArrowLeftInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow-left"),React.createElement("path",{"d":"M18.75,8.75H4.26L7.13,5.89A1.26,1.26,0,0,0,5.36,4.11l-5,5a1.22,1.22,0,0,0-.27.41,1.3,1.3,0,0,0,0,1,1.17,1.17,0,0,0,.27.42l5,5a1.26,1.26,0,0,0,1.77,0h0a1.25,1.25,0,0,0,0-1.77h0L4.26,11.25H18.75a1.25,1.25,0,0,0,0-2.5Z","transform":"translate(0 -3.74)","key":1})]);
}

IconArrowLeftInline.defaultProps = {"id":"arrow","width":"20","height":"12.52","viewBox":"0 0 20 12.52"};

module.exports = IconArrowLeftInline;

IconArrowLeftInline.default = IconArrowLeftInline;
